import { ApiHelper } from '@nykaa/utils/network';
import { ROUTES, getUrl } from 'shared/api/urls';
import { logger } from '@nykaa/logger';
import { contentTypes } from 'constants/requestHeaders';
import { standardErrorMessages } from 'shared/constants';
import { queryStringFromParams } from '@nykaa/utils/urls';
import { transformAboutUs, transformPriceList } from './transformer';

const SUBSCRIPTION_SUCCESS = 'Thanks For Subscribing';

export const subscribeToNewsLetter = async (email: string) => {
  const url = getUrl(ROUTES.NEWS_LETTER_SUBSCRIPTION);
  const urlParams = new URLSearchParams();
  urlParams.append('email', email);

  try {
    await ApiHelper(url, 'POST', urlParams, {
      'Content-Type': contentTypes.URL_ENCODED,
    });
    return { error: false, message: SUBSCRIPTION_SUCCESS };
  } catch (e) {
    logger.error(e, 'Error Subscribing to news letter');
    return { error: true, message: standardErrorMessages.SOMETHING_WRONG };
  }
};

export const getCategoryPriceList = async (params: any) => {
  const url = getUrl(ROUTES.CATEGORY_PRICE_LIST);
  const queryString = queryStringFromParams(params);
  try {
    const {
      data: { response },
    } = await ApiHelper(`${url}${queryString}`, 'get');

    return transformPriceList(response);
  } catch (e) {
    logger.error(e, 'Error fetching price list');
    throw e;
  }
};

export const getFooterCategories = async (params: any) => {
  const url = getUrl(ROUTES.FOOTER_CATEGORIES);
  const queryString = queryStringFromParams(params);
  try {
    const {
      data: { response },
    } = await ApiHelper(`${url}${queryString}`, 'get');
    return response;
  } catch (e) {
    logger.error(e, 'Error fetching Footer Categories');
    throw e;
  }
};

export const getAboutUs = async (params: any) => {
  const url = getUrl(ROUTES.ABOUT_US);
  const queryString = queryStringFromParams(params);
  try {
    const {
      data: { response },
    } = await ApiHelper(`${url}${queryString}`, 'get');

    return transformAboutUs(response);
  } catch (e) {
    logger.error(e, 'Error fetching get About us');
    throw e;
  }
};
